var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynnexLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 358.77 74.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #009ea7;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e73835;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #0068b6;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #b72827;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #005293;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #008086;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #bebfc0;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #9e9e9f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "35.55 36.29 31.74 29.62 27.92 36.28 8.86 36.27 22.2 12.46 41.27 12.46 45.07 20.09 48.89 12.46 67.95 12.46 81.29 36.27 62.23 36.27 58.42 29.62 54.61 36.27 35.55 36.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.63 46.76 76.52 46.76 72.49 53.43 17.41 53.43 13.63 46.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.4 55.33 45.07 55.33 41.24 62 22.2 62 18.4 55.33"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.43 44.86 62.24 38.19 81.31 38.19 77.49 44.86 58.43 44.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.72 44.86 27.91 38.19 8.84 38.19 12.66 44.86 31.72 44.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.6 38.19 35.55 38.19 31.74 44.86 58.42 44.86 54.6 38.19"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "41.27 12.46 31.74 29.62 35.56 36.29 45.08 20.08 41.27 12.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "67.95 12.48 58.43 29.62 62.22 36.27 81.28 36.27 67.95 12.48"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "49.89 46.76 46.16 53.42 72.58 53.42 76.52 46.76 49.89 46.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "45.08 55.34 48.91 62.01 67.93 62 71.76 55.33 45.08 55.34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "54.62 38.2 50.83 44.84 58.42 44.9 54.62 38.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "81.31 38.2 77.49 44.87 58.44 44.87 62.25 38.2 81.31 38.2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "350.12 15.68 339.85 15.68 328.02 31.77 323.21 15.68 311.71 15.68 320.63 37.04 301.36 58.82 311.52 58.82 324.16 42.32 330.01 58.82 341.48 58.82 331.79 36.02 350.12 15.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "276.52 52.96 279.17 40.29 298.83 40.29 300.18 34.32 280.38 34.32 283.43 21.76 306.46 21.76 307.87 15.68 274.5 15.68 264.96 58.82 299.35 58.82 300.56 52.96 276.52 52.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "254.29 49.4 240.21 15.68 229.42 15.68 219.89 58.82 229.48 58.82 235.68 25.4 249.68 58.82 260.37 58.82 269.9 15.68 260.41 15.68 254.29 49.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "209.43 49.4 195.36 15.68 184.58 15.68 175.14 58.82 184.61 58.82 190.88 25.55 204.83 58.82 215.52 58.82 225.15 15.68 215.56 15.68 209.43 49.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "171.49 15.68 157.26 35.22 151.82 15.68 140 15.68 149.83 43.87 146.52 58.82 156.89 58.82 160.59 42.56 181.89 15.68 171.49 15.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121.25,20.11c3.03,0,5.3.77,6.75,2.28.51.53.9,1.13,1.17,1.8h10.07c-.22-3.17-1.35-5.6-3.26-7.06h-.02c-2.57-2.04-6.48-3.1-11.29-3.1-3.76,0-7.4.63-10.53,1.81-3,1.14-5.64,2.81-7.24,4.59-1.88,1.89-3.1,3.99-3.54,6.11-.04.46-.19.87-.31,1.17-.04.12-.11.29-.11.33,0,.36-.03.79-.07,1.2v.13c-.03.19-.04.33-.04.43-.06,2.16.34,5.02,2.57,6.52,2.39,1.84,6.08,3.43,10.41,4.48,3.14.78,5.78,1.75,7.43,2.71,2.37,1.18,3.45,3.78,2.61,6.31-1.02,3.25-4.43,5.11-9.34,5.11-2.09,0-4.36-.62-5.94-1.63-1.28-.89-2.16-2.12-2.62-3.67h-10.15c.04,2.99,1.09,5.4,3.12,7.17,2.99,2.39,7.13,3.66,11.95,3.66,5.56,0,10.66-1.18,15.61-3.59,3.9-1.9,6.64-5.63,7.7-10.5.07-.96.19-1.86.26-2.34l.02-.15c.02-.12.03-.18.03-.22.16-2.43-.56-4.24-2.33-5.84-1.89-1.51-5.25-3.02-8.96-4.04-1.49-.46-3.44-1-5.12-1.42-2.62-.75-4.09-1.46-5.09-2.46-1.38-1.17-2.02-3.18-1.59-5.09.28-1.41,1.61-4.71,7.87-4.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynnexLogoWhite);
export default __webpack_public_path__ + "static/media/Synnex-logo-white.8b3b4160bea7e0369c76b577384d9b45.svg";
export { ForwardRef as ReactComponent };